// extracted by mini-css-extract-plugin
module.exports = {"container":"tags_container__AEWpb","tag":"tags_tag__zKfe7","tagText":"tags_tagText__dkbvi"};